var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid43({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.79,10.82,10.88,12a5.15,5.15,0,0,1-1.29-.91,3.24,3.24,0,0,1-1,.64,3.78,3.78,0,0,1-1.28.2,2.81,2.81,0,0,1-2.21-.82,2.13,2.13,0,0,1-.58-1.48A2.22,2.22,0,0,1,5,8.26a3.73,3.73,0,0,1,1.35-1A4.38,4.38,0,0,1,5.7,6.3a2,2,0,0,1-.2-.82,1.55,1.55,0,0,1,.57-1.21,2.43,2.43,0,0,1,1.63-.5,2.3,2.3,0,0,1,1.6.53,1.64,1.64,0,0,1,.57,1.27,1.62,1.62,0,0,1-.28.91,4,4,0,0,1-1.15,1L9.53,8.89A4,4,0,0,0,9.87,8l1.36.31a10,10,0,0,1-.35,1.06,2.67,2.67,0,0,1-.33.56,6.1,6.1,0,0,0,.66.52A4.41,4.41,0,0,0,11.79,10.82ZM7.09,8.18a2.06,2.06,0,0,0-.77.63,1.27,1.27,0,0,0-.26.76,1,1,0,0,0,.32.8,1.2,1.2,0,0,0,.85.31,1.81,1.81,0,0,0,.69-.14,3.32,3.32,0,0,0,.71-.47Zm.6-1.64.4-.31a.93.93,0,0,0,.45-.69A.67.67,0,0,0,8.33,5a.86.86,0,0,0-.59-.2A.8.8,0,0,0,7.18,5,.54.54,0,0,0,7,5.43a1.17,1.17,0,0,0,.34.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid43);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_43.b7ed08ea1ca9a1c0a0ae0bd30b84238c.svg";
export { ForwardRef as ReactComponent };